/**
 * AppInitializer - Orchestrates sequential app initialization flow
 *
 * Renders a loading screen while the useAppInitialization hook handles:
 * 1. Token extraction (AuthProvider)
 * 2. Module fetching/selection
 * 3. Deep link handling
 * 4. Organization fetching (Manage module)
 * 5. Navigation to appropriate landing page
 *
 * @see useAppInitialization hook for detailed initialization logic
 */

import { AppLoader } from '@shared/components/app-loader/AppLoader';
import { ErrorPage } from '@shared/components/error-pages/ErrorPage';
import * as React from 'react';

import { useAppInitialization } from './hooks/use-app-initialization/useAppInitialization';

const AppInitializer = React.memo((): React.ReactElement => {
  const { errorType } = useAppInitialization();

  if (errorType) {
    return <ErrorPage type={errorType} />;
  }

  return <AppLoader />;
});

AppInitializer.displayName = 'AppInitializer';

export { AppInitializer };
